<p-dialog
  [(visible)]="visible"
  class="request-info-dialog"
  (onHide)="closeDialog()"
  [style]="{ width: '650px', height: '600px' }"
  header="Request Additional Info"
>
  <div class="d-flex flex-wrap h-100 d-flex-column">
    <div class="flex-shrink-1">
      <div class="d-flex flex-wrap w-100 d-flex-row">
        <div class="flex-shrink-1 pr-2">Request:</div>
        <div class="flex-grow-1">
          <p-dropdown
            (ngModelChange)="choiceChosen($event)"
            [(ngModel)]="requestInfoId"
            [options]="requestInfoChoices"
          ></p-dropdown>
        </div>
      </div>
    </div>

    <div *ngIf="requestInfoId == 0 || requestInfoId == null" class="flex-grow-1 pt-2">
      <div style="clear: both"></div>
      <img src="assets/images/chargeRejection.png" style="width: 100%" />
    </div>

    <div
      class="flex-grow-1"
      *ngIf="requestInfoId > 0"
      style="background-color: #f8f8f8; padding: 15px; margin-top: 15px"
    >
      <form [formGroup]="editForm" style="height: 100%">
        <div class="loadingMessage text-center p-3" *ngIf="loading">
          <i class="fa fa-2x fa-spin fa-spinner"></i>
        </div>

        <input type="hidden" formControlName="templateWrapperId" />

        <div class="d-flex h-100 d-flex-column" *ngIf="!loading">
          <div class="flex-shrink-1">
            <div class="d-flex flex-wrap d-flex-row w-100 grid-gap-10">
              <div class="flex-grow-1">
                <div class="from pb-2">To</div>
                <div class="pb-3">
                  <input
                    pInputText
                    formControlName="questionRecipientAddress"
                    class="messageInput"
                    style="width: 100%"
                  />
                </div>
              </div>
            </div>
            <div class="d-flex flex-wrap d-flex-row w-100 grid-gap-10">
              <div class="flex-grow-1">
                <div class="from pb-2">From Name</div>
                <div class="pb-3">
                  <input
                    pInputText
                    formControlName="questionFromName"
                    class="messageInput"
                    style="width: 100%"
                  />
                </div>
              </div>

              <div class="flex-grow-1">
                <div class="from pb-2">From E-mail</div>
                <div class="pb-3">
                  <input
                    pInputText
                    formControlName="questionFromAddress"
                    class="messageInput"
                    style="width: 100%"
                  />
                </div>
              </div>

              <div class="flex-grow-1">
                <div class="from pb-2">Reply-To E-mail</div>

                <div class="pb-3">
                  <input
                    pInputText
                    [placeholder]="editForm.get('questionFromAddress').value"
                    formControlName="questionReplyToAddress"
                    class="messageInput"
                    style="width: 100%"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="flex-shrink-1">
            <div class="pb-2">Subject</div>
            <div class="pb-3">
              <input pInputText class="messageInput w-100" formControlName="questionSubject" />
            </div>
          </div>

          <div class="flex-shrink-1">
            <div class="pb-2">Message</div>
          </div>
          <div class="flex-grow-1">
            <textarea
              class="messageInput"
              pInputTextarea
              formControlName="questionText"
              style="width: 100%; height: 100%; padding: 10px"
            ></textarea>
          </div>
        </div>
      </form>
    </div>
  </div>

  <p-footer class="rounded-bottom-border">
    <div class="text-right" *ngIf="requestInfoId">
      <button pButton label="Cancel" (click)="closeDialog()" class="ui-button-tertiary"></button>
      <button
        pButton
        [disabled]="isSending"
        [label]="isSending ? 'Wait' : 'Send'"
        (click)="sendRequestInfoMail()"
        class="ui-button-primary"
      ></button>
    </div>
  </p-footer>
</p-dialog>
